<template>
  <div>
    <div class="head">
      <h3>信用额度</h3>
    </div>
    <div class="title">
      <h3><span>您的信用额度：</span><span>{{credit}} 元</span></h3>
      <h3><span>您的使用额度：</span><span>{{credit_used}} 元</span></h3>
      <h3><span>您的剩余额度：</span><span>{{credit_balance}} 元</span></h3>
    </div>
    <div class="table">
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="create_time" label="创建时间" width="250">
        </el-table-column>
        <el-table-column prop="11" label="付款类型">
          <span slot-scope="scope">
            {{ ["线下充值", "扣款"][scope.row.type] }}
          </span>
        </el-table-column>
        <el-table-column prop="money" label="金额">
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="400"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      credit:''
    };
  },
  methods:{
   getInfo(){
        this.$api.personalInfo.getuser({}).then((res) => {
          this.credit = res.data.credit;
          this.credit_used = res.data.credit_used
          this.credit_balance = res.data.credit_balance
        });
   }
  },
  created() {
    this.$api.balance.creditBalance({}).then(res=>{
      if(res.status == 1){
        this.tableData = res.data
        this.getInfo()
      }
    })
  },
};
</script>

<style lang="less" scoped>
*{
  font-size: 15px;
}
  .head {
    h3 {
      height: 31px;
      font-size: 24px;
      color: #333333;
    }
  }
.title{
  font-size: 18px;
  color:#003871;
  margin-top:20px;
  margin-bottom:5px;
  display: flex;
  h3{
    margin-right: 20px;
  }
}
/deep/.el-table th, .el-table tr {
  background: #f5f5f5;
   color:#000;
}
</style>